/**
 * SubPage Component
 * 서브 페이지 애니메이션 관리
 */

export class SubPage {
    constructor() {
        // GSAP과 ScrollTrigger가 로드되었는지 확인
        if (typeof gsap === "undefined") {
            console.warn("GSAP not loaded");
            return;
        }

        if (typeof ScrollTrigger !== "undefined") {
            gsap.registerPlugin(ScrollTrigger);
        }
    }

    hero() {
        const heroSection = document.querySelector(".no-sub-hero");
        if (!heroSection) return;

        const heroBackground = heroSection.querySelector(".no-sub-hero__background");
        const heroImage = heroSection.querySelector("[data-hero-image]");
        const heroImageMask = heroSection.querySelector("[data-hero-image-mask]");

        if (!heroBackground || !heroImage || !heroImageMask) return;

        // 초기 상태 설정 - 마스크는 투명하게 유지 (CSS에서 opacity: 0으로 설정됨)
        gsap.set(heroImageMask, {
            scaleX: 1,
            transformOrigin: "left",
        });

        // 이미지가 로드되면 표시
        const showImage = () => {
            // fallback 이미지(thumb.png)가 아닌 경우에만 표시
            if (!heroImage.src.includes('thumb.png') && heroImage.naturalWidth > 0) {
                gsap.set(heroImage, {
                    opacity: 0.8,
                    scale: 1.2,
                });
            } else {
                // fallback 이미지이거나 로드 실패 시 배경 영역 자체를 숨김
                gsap.set(heroBackground, { display: 'none' });
            }
        };

        if (heroImage.complete) {
            showImage();
        } else {
            heroImage.addEventListener('load', showImage);
            heroImage.addEventListener('error', () => {
                // 이미지 로드 실패 시 배경 영역 숨김
                gsap.set(heroBackground, { display: 'none' });
            });
        }

        // ScrollTrigger로 마스크 애니메이션 (고급스러운 timeline)
        ScrollTrigger.create({
            trigger: heroBackground,
            start: "top 85%",
            end: "top 15%",
            once: true,
            onEnter: () => {
                const tl = gsap.timeline({
                    defaults: {
                        ease: "power3.inOut",
                    },
                });

                // 마스크가 나타났다가 왼쪽에서 오른쪽으로 사라짐 (부드러운 애니메이션)
                tl.set(heroImageMask, { opacity: 1 }, 0);
                tl.to(heroImageMask, {
                    scaleX: 0,
                    duration: 1.6,
                    ease: "power3.inOut",
                }, 0);

                // 이미지가 확대되면서 나타남 (약간의 딜레이로 자연스러운 효과)
                tl.to(heroImage, {
                    scale: 1,
                    opacity: 1,
                    duration: 1.8,
                    ease: "power3.out",
                }, 0.2);
            },
        });
    }
}
